import axios from '../axios'


export async function deleteCount(payload) {
    return axios.delete(`/inventory/counts/items/` + payload )
        .then((response) => {
        return response.data
    })
        .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}



// Updates multiple items at the same time. 
export async function updateCountItems(payload) {
    const id = payload.countId
    const data = payload.data 
    return axios.put(`/inventory/counts/${id}/items/list`, { data } )
    .then((response) => {
        // Should return all items, just like the fetchCountItems() method. Not only updated items
        return response.data
    })
    .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}


// Fetches all items for selected COUNT
export async function fetchCountItems(id) {
    return axios.get(`/inventory/counts/${id}/items` )
    .then((response) => {
        return response.data

    })
    .catch((error) => {
        return Promise.reject(error.response?.data || error)
    });
}

// Add item to count
export async function addItemToCount(countId, payload) {
    return axios.post(`/inventory/counts/${countId}/items`, { inventory_count_item: payload })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

// Update item in count
export async function updateItemInCount(countId, itemId, payload) {
    return axios.put(`/inventory/counts/${countId}/items/${itemId}`, { inventory_count_item: payload })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

// Remove item from count
export async function removeItemFromCount(countId, itemId) {
    return axios.delete(`/inventory/counts/${countId}/items/${itemId}`)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

// Bulk import items from CSV/Excel
export async function bulkImportCountItems(countId, payload) {
    return axios.post(`/inventory/counts/${countId}/items/bulk_import`, { data: payload })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

// Approve/Unapprove count item
export async function approveCountItem(countId, itemId, approved) {
    return axios.put(`/inventory/counts/${countId}/items/${itemId}/approve`, { approved })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

// Bulk approve/unapprove count items
export async function bulkApproveCountItems(countId, itemIds, approved) {
    return axios.put(`/inventory/counts/${countId}/items/bulk_approve`, { 
        item_ids: itemIds,
        approved: approved 
    })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return Promise.reject(error.response?.data || error)
        });
}

